import {Component, OnInit} from '@angular/core';
import {PartnerService} from '../../services/partner/partner.service';
import {AbstractInputDirective} from '../AbstractInputDirective';
import {GetPartners} from "../../services/partner/GetPartners";

@Component({
  selector: 'digires-partner-input',
  templateUrl: './partner-input.component.html',
  styleUrls: ['./partner-input.component.scss']
})
export class PartnerInputComponent extends AbstractInputDirective implements OnInit {

  allPartners: GetPartners[];

  constructor(private partnerService: PartnerService) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.partnerService
      .fetchAllPartners()
      .then(value => {
        this.allPartners = value;
      });
  }

  getReadonlyValue(): string {
    const formValue = this.getValue();
    if (!formValue) {
      return null;
    }
    const selectedPartner = this.allPartners?.find(partner => partner.id === formValue);
    return selectedPartner?.name;
  }

}
